import { useLayoutEffect, useRef, useState } from "react";
import { CellChange, Id, Row } from "@silevis/reactgrid";
import { PREFIX_CLASS_ROW } from "@lhd/constants";

interface IProps {
  isAutoHeight?: boolean;
}

export function useAutoRowHeight({ isAutoHeight }: IProps) {
  const pendingRows = useRef(new Set<Id>());

  const [configRowHeights, setConfigRowHeights] = useState<
    Record<string, number>
  >({});

  const rafId = useRef<number>();
  const calcHeight = (rowId: Id) => {
    const cells = document.querySelectorAll("." + PREFIX_CLASS_ROW + rowId);
    let maxHeight = 0;
    cells.forEach((cell) => {
      const child = cell.firstElementChild as HTMLElement | null;
      if (!child) return;
      maxHeight = Math.max(maxHeight, child.scrollHeight);
    });

    return Math.max(maxHeight, 32); // min row height
  };

  const schedule = () => {
    if (rafId.current || !isAutoHeight) return;

    rafId.current = requestAnimationFrame(() => {
      rafId.current = undefined;

      if (pendingRows.current.size === 0) return;

      const ids = Array.from(pendingRows.current);
      pendingRows.current.clear();
      const tmpConfigRowHeights: typeof configRowHeights = {
        ...configRowHeights,
      };
      ids.forEach((rowId) => {
        const height = calcHeight(rowId);
        tmpConfigRowHeights[rowId] = height;
      });
      setConfigRowHeights(tmpConfigRowHeights);
    });
  };

  useLayoutEffect(() => {
    isAutoHeight && schedule();
  });

  const handleCalHeightByCellChange = (changes: CellChange[]) => {
    changes.forEach((c) => pendingRows.current.add(c.rowId));
  };
  const handleCalHeightByRowIds = (rowIds: string[]) => {
    rowIds.forEach((rowId) => pendingRows.current.add(rowId));
  };

  return {
    handleCalHeightByCellChange,
    configRowHeights,
    handleCalHeightByRowIds,
  };
}
